import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

import { listWallboards, LAYOUTS } from './wallboards';
import { HOME_URL, WALLBOARDS_URL } from '../../config';
import { PageHeaderButtons, PageFooterContent } from '../menu';

import { 
    PageFooter,
    PageHeader,
    PageLayout,
    PageSection,
    PageMenu,
    Header,
    Table,
    Widget,
    Button,
    LoadingIndicator,
    InView,
    Icon,
} from '../../components/components';

export function ListWallboardsPage(props) {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [continuationToken, setContinuationToken] = useState("");
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [error, setError] = useState("");
    const [wallboards, setWallboards] = useState([]);

    const load = useCallback(async (loading, wallboards, continuationToken) => {
        if (loading) {
            return;
        }

        setLoading(true);
        setError("");

        const [loaded, newWallboards, newContinuationToken, error] = await listWallboards(continuationToken);
        if (!loaded) {
            setCanLoadMore(false);
            setError(error);
            setLoading(false);
            return;
        }

        const canLoadMore = !newContinuationToken ? false : true;

        setWallboards([...wallboards, ...newWallboards]);
        setContinuationToken(newContinuationToken || "");
        setCanLoadMore(canLoadMore);
        setLoading(false);
    }, []);

    return (
        <PageLayout
            header={<PageHeader name="Puzzel wallboards" menu={<PageMenu><PageHeaderButtons /></PageMenu>} />}
            footer={<PageFooter><PageFooterContent /></PageFooter>}>
            <PageSection>
                <Button variant="label" icon="ic_keyboard_backward" clicked={() => navigate(HOME_URL)}>
                    Home
                </Button>
                <Header>
                    Wallboards
                </Header>
                <p>Monitor your Puzzel queues in real-time.</p>
            </PageSection>
            <PageSection>
                {error &&
                    <Widget variant="alert" class="compact-flex">
                        <Icon name="ic_alert-outline" />
                        {error}
                    </Widget>
                }
                {!error &&
                    <Table class="wallboards">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Layout</th>
                            </tr>
                        </thead>
                        <tbody>
                            {wallboards.map((wallboard, index) => 
                                <tr key={index}>
                                    <td>
                                        <Button
                                            variant="link"
                                            clicked={() => navigate(`${WALLBOARDS_URL}/${wallboard.id}`)}>
                                            {wallboard.name}
                                        </Button>
                                    </td>
                                    <td>
                                        {LAYOUTS[wallboard.type]}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                }
                {loading &&
                    <LoadingIndicator />
                }
                {canLoadMore &&
                    <InView inView={() => load(loading, wallboards, continuationToken)} />
                }
            </PageSection>
        </PageLayout>
    );
}